import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    Inject,
    HostListener,
} from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogState } from "@angular/material/dialog";
import { MatSidenav } from "@angular/material/sidenav";
import { PanierService } from "../../../services/manage/panier/panier.service";
import { AuthService } from "../../../services/auth/auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmorderComponent } from "../../dialogs/confirm-order/confirmorder.component";
import { panierAnim } from "../../../models/consts/anims";
import { MyStripeService } from "../../../services/apiclient/myStripe/my-stripe.service";
import { ClientaddressesService } from "../../../services/apiclient/clientaddresses/clientaddresses.service";
import { InfoNoteService } from "src/app/services/api/infoNote/info-note.service";
import { ToolsService } from "src/app/services/tools/tools.service";
import { MediaObserver } from "@angular/flex-layout";
import { DialogsService } from "src/app/services/manage/dialogs/dialogs.service";
import { forkJoin } from "rxjs";
import { ClientOrdersService } from "src/app/services/apiclient/order/clientorders.service";
import { SalemethodService } from "src/app/services/api/salemethod/salemethod.service";
import { DOCUMENT } from "@angular/common";
import { CurrencyService } from "src/app/services/manage/currency/currency.service";
import { ClientMerchantsService } from "src/app/services/apiclient/clientmerchants/clientmerchants.service";
import { AuthPageManageService } from 'src/app/services/manage/page-manage/auth-page-manage.service';
import { FidelityOrderComponent } from "../../dialogs/fidelity-order/fidelity-order.component";
import { ClientaccountService } from "src/app/services/apiclient/clientaccount/clientaccount.service";
import { PaymentsMethodsCardComponent } from "../../dialogs/payments-methods-card/payments-methods-card.component";
import { ExpireDateDialogComponent } from "../../dialogs/expire-date-dialog/expire-date-dialog.component";
import { borneOrderService } from "src/app/services/borneOrder/borneOrder.service";
import { TranslateService } from "@ngx-translate/core";
import * as moment from "moment";
import { AlertExpireDateProductDialogComponent } from "../../dialogs/alert-expire-date-product-dialog/alert-expire-date-product-dialog.component";
import { ProductService } from "src/app/services/api/product/product.service";
import { Location } from '@angular/common';
import { CssService } from "../../../services/css-service";
import { normalizePos, PointOfSaleDetails } from "src/app/services/api/fulle/fulle-pointOfSale/fulle-pointOfSale.service.interface";
import { OrderErrorHandlerService } from "src/app/services/fulle/orderErrorHandler/orderErrorHandler.service";
import { MathService } from "src/app/services/fulle/math/math.service";
import { LogoAndBannerService } from "src/app/services/fulle/logoAndBanner/logoAndBanner.service";
import { FullePointOfSaleService } from "src/app/services/api/fulle/fulle-pointOfSale/fulle-pointOfSale.service";

@Component({
    selector: "app-fulle-endorder",
    templateUrl: "./fulle-endorder.component.html",
    styleUrls: ["./fulle-endorder.component.css"],
    animations: [panierAnim],
})
export class FulleEndorderComponent implements OnInit {

    @ViewChild("rightNav", { static: true }) rightNav: MatSidenav | any;

    // URL
    url: string = this.router.url;

    // USER
    user$: any;

    // Merchant client
    merchantClient: any;

    // ORDER
    error: string | any;
    errorData: any;

    // ADDRESSES
    clientAddresses$: any;
    currDelivryAddress$: any;
    currBillingAddress$: any;

    // RELAY
    selectedRelay: any;
    isRelay: boolean = false; // Si l'onglet selectionné est l'onglet point relais
    hasRelay: boolean = false; // Si le commerçant gère les relais
    hasOtherThanRelay: boolean = false;

    // CARDS
    clientCards$: any;
    currCard$: any;
    clientCardLoader: boolean = true;

    // INFOSNOTE
    infosNote$: any;

    // SALE_METH
    currSM: any = this.tools.getStor(SalemethodService.TAG_STORAGE);

    // Point of sale
    currPOS: PointOfSaleDetails = normalizePos(this.tools.getStor("point_of_sale"));

    clonecurrPOS: any

    // BASKET DATA
    allTotal: number | any;

    // FLAG RECEIVED DATA
    activePanierButton: boolean = false;

    // Basket side
    basketOpen: boolean = this.media.isActive("gt-sm") ? true : false;
    basketMode: string = this.media.isActive("gt-sm") ? "side" : "over";

    //Payment methods
    showPaymentMethods: boolean = true
    rememberPaymentChoice: string | any;
    currPaymentChoice: string | any;

    stripe: any;

    // Indicateur de l'état de chargement de la page
    pageIsLoading = true;

    // Fidelity basket
    basketFidelityPoints: number = 0;


    /**
     * Observable subs
     */
    addressesSub: any;
    errorOrderSub: any;
    currCardSub: any;
    billingAddressSub: any;
    delivryAddressSub: any;
    basketSub: any;
    infoNoteSub: any;
    _onPopState: any;
    FidelityPointClient: any;
    checFid: any;

    totalPrice: any = 0;
    allPrice: any = 0;
    disabledCagnotte = false;
    showPaymentMethodsTitle = true;

    discountClient = 0;
    totalAfterDiscount = 0;
    fidelityDiscountUsed = 0;
    obserGetUser: any;

    success: any = false;
    deviceChange: any;
    obserRemovePanier: any;
    statusMessage: any = null;
    activeDeviceandButtonTerms = false;

    successYavin: any = false;

    myDialFidelityOrder: any
    fidelityDialogCanopen = true;
    chechFidelityPointUsed = false;


    //paymentsuccess
    savedDataStripe$: any;
    payment_intent$: any;
    nowPayment: any;
    obserProgress: any;
    stopProgress: boolean = false;

    //yavin
    yavin: any;

    maxcall = 0;
    order_id: any;
    errorYetPayed: any = false;

    basketlength = 0;
    successNepting: any;
    obserSuggestionEnd: any

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private orderApi: ClientOrdersService,
        private stripeApi: MyStripeService,
        private panierMan: PanierService,
        private addressApi: ClientaddressesService,
        private clientMerchantApi: ClientMerchantsService,
        private dialog: MatDialog,
        private myDials: DialogsService,
        private authService: AuthService,
        public cssService: CssService,
        private router: Router,
        private posApi: FullePointOfSaleService,
        private infoNoteApi: InfoNoteService,
        private tools: ToolsService,
        private media: MediaObserver,
        private smApi: SalemethodService,
        private currencyMng: CurrencyService,
        private elementRef: ElementRef,
        private authPageServ: AuthPageManageService,
        private clientAccountApi: ClientaccountService,
        private borneOrderService: borneOrderService,
        public translate: TranslateService,
        private prodApi: ProductService,
        private route: ActivatedRoute,
        private location: Location,
        private logoAndBannerService: LogoAndBannerService,
        private errorHandler: OrderErrorHandlerService,
        private mathService: MathService,
        private fullePointOfSaleService: FullePointOfSaleService,
    ) {
        this.media.asObservable().subscribe((media) => {
            this.getSidesResp();
        });

        //si le panier a depassé 12hours
        this.obserRemovePanier = this.tools.getRemovePanier.subscribe((data) => {


            if (data) {
                this.openExpiredateDial();
                this.tools.removePanier.next(false);
            }
        });

        this.prodApi.setObsersuggestionsEnd();
    }

    @HostListener('window: popstate', ['$event'])
    onPopState(event: Event): void {
        //changed
        if (this.tools.getOnPopState() && this.tools.getOnPopState().state) {
            history.forward();
            this.tools.setOnPopState();
        }
    }

    // Initialisation du composant
    async ngOnInit(): Promise<void> {
        const PosId = this.tools.getStor("id_merchant")

        const pos_list = await this.fullePointOfSaleService.getPointOfSaleDetails(PosId, '', 'timetables,payment_methods');
        // console.log('pos_list : ', pos_list);
        const pos_en_storage = this.tools.getStor("point_of_sale");
        // console.log('pos_en_storage : ', pos_en_storage);
        const id_webshop = pos_en_storage.idWebshop;
        // console.log('id_webshop : ', id_webshop);

        const current = pos_list.find(p => p.idWebshop === id_webshop);
        // console.log('current payment_methods', current?.payment_methods);
        if (pos_list && current) {
            this.currPOS = current;
            this.tools.setStor("point_of_sale", this.currPOS);
        }

        this.errorHandler.setContext({
            // Configure les méthodes à appeler en cas d'erreur
            toggleBasket: () => this.toggleBasket(),
            openAlertProductValidity: (d) => this.openAlertProductValidty(d),
        });
        this.route.params.subscribe((params: any) => {
            // Si retour de paiement Nepting
            if (params.nepting && params.payment) {
                // Gérer le paiement Nepting
                if (this.onNeptingPaymentCallback(params)) {
                    return;
                }
            }
        })
        this.getobserSuggestionEnd();
        this.statusMessage = "credit_due.loader_trai";
        // Rechargement des zones éligibles si manquantes
        this.checkAndReloadEligibleZones();
        // Vérifie si la méthode de vente est archivée
        this.ckeckSaleMethods();
    }

    // Gérer le retour de paiement Nepting
    onNeptingPaymentCallback(params: any): boolean {
        // Paiement réussi
        if (params.payment == "success") {
            this.setPageIsLoading(true);
            this.statusMessage = "credit_due.loader_trai";
            this.successNepting = true;
            this.orderApi.endOrder(params.nepting);
            return true;
        }
        // Erreur de paiement
        else if (params.payment == "cancel" || params.payment == "error" || params.payment == "refused") {

            this.translate.get("nepting." + params.payment).subscribe((trad: string) => {
                this.tools.openSnackBar(trad, "warn", 2000);
            })
            this.location.replaceState("endorder");
        }
        return false;
    }

    /**
     * La méthode init initialise plusieurs éléments.
     * Elle vérifie d'abord si le paiement est en mode Bancontact ou Yavin,
     * elle vérifie le montant minimum de commande, si le mode relais est activé,
     * et soumet la commande pour la sauvegarder.
     * Elle gère également la connexion de l'utilisateur.
     */
    init(): void {
        // Vérifier si Bancontact
        this.checkPaymentIntent();

        // Vérifier si Yavin
        this.checkPaymentYavin();

        // Vérification du montant minimum de commande
        this.checkMiniAmount();

        // Vérification du mode relais
        this.checkHasRelay();

        // Soumission de la commande
        this.setCommand();

        // Gère la connexion de l'utilisateur
        this.obserGetUser = this.authService.getUser.subscribe((user) => {
            if (!user) {
                if (!this.currSM.disable_authentification) {
                    setTimeout(() => {
                        this.authPageServ.goLogin("endorder");
                    });
                } else if (this.currSM.disable_authentification) {
                    this.addressApi.setBillingAddress(this.currPOS.address);
                    this.clientAccountApi.getClientAccount().subscribe(user_ => {
                        this.user$ = user_;
                        this.initDatas();
                    })
                }
            } else if (user && !this.user$) {
                this.smApi.setSaleMeth(this.currSM, true);
                this.user$ = user;
                this.initDatas();
            }
        });
    }

    // Se désabonne de tous les abonnements pour éviter les fuites de mémoire.
    ngOnDestroy(): void {
        if (this.addressesSub) {
            this.addressesSub.unsubscribe();
        }
        if (this.errorOrderSub) {
            this.errorOrderSub.unsubscribe();
        }
        if (this.currCardSub) {
            this.currCardSub.unsubscribe();
        }
        if (this.billingAddressSub) {
            this.billingAddressSub.unsubscribe();
        }
        if (this.delivryAddressSub) {
            this.delivryAddressSub.unsubscribe();
        }
        if (this.basketSub) {
            this.basketSub.unsubscribe();
        }
        if (this.infoNoteSub) {
            this.infoNoteSub.unsubscribe();
        }
        if (this.obserGetUser) {
            this.obserGetUser.unsubscribe();
        }
        if (this.obserRemovePanier) {
            this.obserRemovePanier.unsubscribe();
        }
        if (this.obserSuggestionEnd) {
            this.obserSuggestionEnd.unsubscribe();
        }
    }

    // Initialisation des suggestions de fin
    getobserSuggestionEnd(): void {
        this.prodApi.getObsersuggestionsEnd().subscribe(sugges => {
            if (sugges == "fid") {
                this.setPageIsLoading(false, "verify");
                if (this.merchantClient!.fidelity_points && this.merchantClient!.fidelity_points > 0) {
                    // Si points de fidélité
                    this.checkFidelityPoints();
                } else {
                    // Réinitialiser
                    const fidpoints = this.tools.getStor('fidpoints');
                    if (fidpoints) {
                        this.resetFidelityPoints();
                    }
                    this.tools.removeStor('fidpoints');
                }
            }
        })
    }

    // Initialisation des données
    initDatas(): void {
        const currSM: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
        if (!currSM) {
            return;
        }
        forkJoin(
            this.addressApi.getClientAddresses(),
            this.clientMerchantApi.getMerchantClient(),
        ).subscribe(([
            addresses,
            merchantClient
        ]) => {
            this.clientAddresses$ = this.currSM.disable_authentification ? this.currPOS.address : addresses;
            // Charges les cartes clients pour Stripe (processus de paiement en ligne)
            if (!this.currSM.enable_device_check) {
                this.clientCards$ = [];
            }

            this.clientCardLoader = false;
            this.activePanierButton = true;
            this.merchantClient = merchantClient;
            this.roundedValCagnotteRemise();

            if (!this.currSM.enable_device_check) {
                // Remise par fidélité
                if (this.merchantClient!.id_group) {
                    // on applique les éventuelles réductions
                    this.getPriceRemise();
                    this.checkMiniAmount();
                }
                // Vérification des points de fidélité
                this.suggestion();
            } else {
                this.setPageIsLoading(false, "verify");
                this.statusMessage = null;
            }
            if (!this.currSM.enable_device_check) {
                if (this.currSM.use_client_credit_fid) {
                    this.toggleCagnotteFid();
                }
                if (this.currSM.use_client_credit) {
                    this.toggleCagnotte();
                }
                if (this.currSM.use_client_credit || this.currSM.use_client_credit_fid) {
                }
            }

        });

        // Surveille les adresses clients
        this.addressesSub = this.addressApi.getAddresses.subscribe(addresses => {
            if (addresses) {
                this.clientAddresses$ = addresses;
            }
        })

        // Surveille les erreurs de commande
        this.errorOrderSub = this.orderApi.getErrorOrderData.subscribe((error) => {

            if (error) {
                this.errorData = error;
            }
        });

        if (!this.currSM.enable_device_check) {
            // Surveille la carte courante
            this.currCardSub = this.stripeApi.getCurrCard().subscribe((card) => {
                this.currCard$ = card;
            });
        }

        // Surveille l'adresse de facturation courante
        this.billingAddressSub = this.addressApi.getBillingAddress.subscribe((address) => {
            this.currBillingAddress$ = address;
        });

        // Adresse de livraison
        this.delivryAddressSub = this.addressApi.getDelivryAddress.subscribe((address) => {
            this.currDelivryAddress$ = address;
            // console.log("fulle-endorder.component - initDatas - address : ", address);
            setTimeout(() => {
                this.allTotal = this.panierMan.getPriceWithDiscountClientAndFidelity(this.panierMan.getPanInfos("allship"), this.discountClient, this.fidelityDiscountUsed);
                if (this.currSM.use_client_credit_fid) {
                    this.toggleCagnotteFid();
                }
            });
        });

        // Surveillance du Panier
        this.basketSub = this.panierMan.getPanier.subscribe((basket) => {
            this.basketlength = basket && basket.length > 0 ? basket.length : 0;
            if (basket && basket.length > 0) {
                if (this.tools.checkCurrentPage('endorder')) {
                    setTimeout(() => {
                        this.allPrice = this.panierMan.getPrice();
                        if (!this.currSM.enable_device_check) {
                            // Remise si applicable
                            if (this.merchantClient && this.merchantClient.id_group) {
                                // On vérifie que les remises s'appliquent sur les nouvelles entrées
                                this.getPriceRemise();
                            }
                            this.allTotal = this.panierMan.getPriceWithDiscountClientAndFidelity(this.panierMan.getPanInfos("allship"), this.discountClient, this.fidelityDiscountUsed);
                            this.toggleCagnotteFid();
                        }
                    });
                }
            }
        });

        // Surveillance des notes
        this.infoNoteSub = this.infoNoteApi.getInfosNote().subscribe((infos: any) => {
            if (infos) {
                if (this.currSM.disable_authentification_info_notes) {
                    infos.forEach((element: any) => {
                        if (element.id == this.currSM.disable_authentification_info_notes.id) {
                            element.value = this.currSM.disable_authentification_info_notes.value;
                        }
                    });
                }
                this.infosNote$ = infos;
                this.tools.setStor("infos_note", infos);
            } else {
                this.tools.removeStor("infos_note");
            }
        });

        // Initialiser PayPal si configuré
        if (!this.currSM.enable_device_check && this.currPOS.paypalAccount) {
            this.initScriptPaypal(this.currPOS.paypalAccount);
        }
        this.checkModeborne();
        this.tablecommand();

        // Ajoute des valeurs size au logo et à la bannière
        this.logoAndBannerService.initLogoAndBannerDetails(this.currPOS).then((enrichedPoint: PointOfSaleDetails) => {
            if (enrichedPoint) {
                this.currPOS = enrichedPoint;
            }
        });
    }

    // Vérifie si l'application est en mode borne (terminal de paiement)
    checkModeborne(): void {
        this.activeDeviceandButtonTerms = false;

        // Utiliser "devicePaybridge"
        const devicePaybridge = this.currSM.disable_authentification && this.tools.getStor("devicePaybridge") ? this.tools.getStor("devicePaybridge") : null;
        devicePaybridge ? this.borneOrderService.continueOrder("order") : this.borneOrderService.removeContinueOrderTimeout()

        if (devicePaybridge && this.currSM && this.currSM.disable_authentification) {
            this.activeDeviceandButtonTerms = true;
        }
    }

    // Commande à table (assise)
    tablecommand(): void {
        if (this.currSM.enable_device_check) {
            this.activeDeviceandButtonTerms = true;
            this.currPaymentChoice = null;
            this.showPaymentMethods = false;
            this.showPaymentMethodsTitle = false;
        }
    }

    // Suggestions de produits
    suggestion(): void {
        this.prodApi.setObsersuggestionsEnd(false);
        const SuggestionsEndUsed = this.tools.getStor('SuggestionsEnd') ? this.tools.getStor('SuggestionsEnd') : null;
        if (!SuggestionsEndUsed) {
            this.setPageIsLoading(false, "verify");
            this.prodApi.checkProductsSuggestionsEnd(this.merchantClient);
        } else {
            this.setPageIsLoading(false, "verify");
            this.statusMessage = null;
            this.prodApi.setObsersuggestionsEnd("fid");
        }
    }

    // Soumettre la commande pour la sauvegarder dans le système
    setCommand(): void {
        this.order_id = this.tools.getStor("order_id") ? this.tools.getStor("order_id") : null;
        if (this.savedDataStripe$ || this.yavin) {
            return;
        }
        this.orderApi.submitOrder().then((data: any) => {
            if (data) {
                if (data.code == 100) {
                    // Enregistrement réussi
                    this.tools.setStor("order_id", data.list.order.id);
                    this.order_id = this.tools.getStor("order_id") ? this.tools.getStor("order_id") : null;
                } else if (data.code == -100) {
                    // Erreur de paiement déjà traité
                    this.errorYetPayed = true;
                }
            }
        });
    }

    // Réinitialiser les erreurs de paiement
    clearErrors(error: string | null): void {
        this.error = error;
    }

    // Simplifier la gestion des erreurs
    readErrors(error: string): void {
        // Déclenche les erreurs en utilisant le gestionnaire d'erreurs
        const errorData = this.prepareErrorData(error);
        this.errorHandler.handleError(error, errorData);
    }

    // Préparer des données pour des erreurs spécifiques
    private prepareErrorData(error: string): unknown {
        switch (error) {
            case 'maxweight':
                return {
                    deliveryAddress: this.currDelivryAddress$,
                    isRelay: this.isRelay,
                    selectedRelay: this.selectedRelay
                };

            case 'countryshipping':
            case 'citydelivery':
                return {
                    deliveryAddress: this.currDelivryAddress$
                };

            case 'invalidrub':
            case 'invalidpriceperiod':
            case 'invalidDateproduct':
                return this.errorData;

            case 'currSalemethodArchive':
                return {
                    currSM: this.currSM,
                    currPOS: this.currPOS
                };

            default:
                return null;
        }
    }

    // Vérifier si la méthode de vente n'est pas archivée
    ckeckSaleMethods(): void {
        if (this.currPOS) {
            this.smApi.getSaleMethods().subscribe((saleMeths) => {
                const currSm = saleMeths.find((value: any) => value.id == this.currSM.id);

                if (currSm && currSm.archive > 0) {
                    this.myDials.openInvalidSalemethodDial(this.currSM, this.currPOS);
                }
                this.init();
            })
        } else {
            this.checkPaymentIntent();
            this.checkPaymentYavin();
            this.tools.openSnackBar(this.translate.instant('endOrderComponent.error'), "warn", 4000);

            // Réinitialiser les valeurs et redirection
            this.tools.goProductPage();
            console.error("error")
        }
    }

    // Vérifie le montant minimum de commande requis
    checkMiniAmount(): void {
        const price = this.merchantClient && this.merchantClient.id_group && (this.merchantClient.discount || this.merchantClient.groups_discount)
            ? this.panierMan.getTotalAfterDiscount(this.merchantClient)
            : this.panierMan.getPrice()
        const basket = this.tools.getStor(PanierService.TAG_STORAGE) ? this.tools.getStor(PanierService.TAG_STORAGE) : null;
        if (basket && basket.length > 0) {
            if (price < this.currSM.minimum_order) {
                this.myDials.openMiniAmountDial();
            }
        }
    }

    // Vérifie si le commerçant gère les points relais
    checkHasRelay(): void {
        if (this.currSM.enable_shipping_cost > 0 && this.currPOS.shippingCosts) {
            // Vérifie l'existence du mode relais
            for (let i = 0; i < this.currPOS.shippingCosts.length; i++) {
                const cost = this.currPOS.shippingCosts[i];
                if (cost.is_relay > 0) {
                    this.hasRelay = true;
                }
                if (cost.is_relay < 1) {
                    this.hasOtherThanRelay = true;
                }
            }
        } else if (this.currSM.enable_shipping_cost < 1) {
            this.hasOtherThanRelay = true;
        }

        // Si le relais est la seule option disponible, sélectionne automatiquement
        if (this.hasRelay && !this.hasOtherThanRelay) {
            this.isRelay = true;
        }
    }

    // Vérification du paiement Yavin
    checkPaymentYavin(): void {
        this.successYavin = false;
        const url = new URL(window.location.href);
        this.yavin = url.searchParams.get('cartId');
        const status = url.searchParams.get('status');

        // Paiement réussi
        if (this.yavin) {
            this.statusMessage = null;
            this.setPageIsLoading(true);

            // Vérification du statut du paiement
            if (status == 'ok' || status == 'authorised') {
                this.successYavin = true;
                this.orderApi.yavinPaymentSucceeded(this.yavin, status).then((data: any) => {
                    if (data && data.code == 0) {
                        if (this.myDialFidelityOrder) {
                            this.myDialFidelityOrder.close()
                        }
                        this.setPaymentChoice("yavin");
                        this.orderApi.endOrder(this.yavin);
                        this.successYavin = false;

                    } else {
                        this.erroPaymentIntentSuccess(data && data.error_yavin && data.error_yavin && data.error_yavin.message
                            ? data.error_yavin.message : null);
                    }
                })
            } else {
                this.erroPaymentIntentSuccess();
            }
            return;
        }
    }

    // Erreur lors du paiement
    erroPaymentIntentSuccess(message?: any): void {
        this.tools.openSnackBar(message ? message : this.translate.instant('booking.error_pay'), "warn", 5000);
        setTimeout(() => {
            // Réinitialise et redirige vers la page de fin de commande
            this.router.navigate(["/endorder"]);
            this.setPageIsLoading(false);
            this.successYavin = false;
            this.success = false;
        }, 2500);
    }

    // Vérifie si on vient d’une redirection après un paiement Bancontact
    checkPaymentIntent(): void {
        this.success = false;
        const url = new URL(window.location.href);
        const clientSecret = url.searchParams.get('payment_intent_client_secret');

        const status = url.searchParams.get('redirect_status');

        this.savedDataStripe$ = this.tools.getStor("payment_save_order_stripe");

        if (clientSecret) {
            this.payment_intent$ = url.searchParams.get('payment_intent');

            if (this.savedDataStripe$) {
                this.statusMessage = null;
                this.setPageIsLoading(true);

                if (status === "succeeded") {
                    this.success = true;
                    this.nowPayment = moment();
                    this.progressPaymentObservable();
                    this.stripeApi.setProgressPaymentStripe(true);
                } else {
                    this.setPageIsLoading(false);
                    this.savedDataStripe$ = null;
                    this.tools.removeStor("payment_save_order");
                    this.tools.removeStor("payment_save_order_stripe");
                    this.erroPaymentIntentSuccess();
                }
                return;
            }
        } else {
            if (this.savedDataStripe$) {
                this.checkOrderPayment();
            } else {
                this.tools.removeStor("payment_save_order");
                this.tools.removeStor("payment_save_order_stripe");
            }
        }
        return;
    }

    // Définir les cartes client
    setClientCards(cards: any): void {
        this.clientCards$ = cards;
    }

    setPaymentChoice_(paymentChoice: any): void {
        if (this.activeDeviceandButtonTerms) {
            paymentChoice = paymentChoice == "counter" || paymentChoice == "touch_terminal" ? paymentChoice : "touch_terminal";
        }
        if (paymentChoice == "touch_terminal") {
            paymentChoice = !this.tools.getStor("devicePaybridge") ? null : paymentChoice;
        }

        if (!paymentChoice) {
            this.currSM.payment_type = null;
            this.rememberPaymentChoice = null;
        }
        this.setPaymentChoice(paymentChoice);
    }

    // Sélection de la méthode de paiement
    setPaymentChoice(paymentChoice?: string): void {
        if (paymentChoice) {
            if (this.activeDeviceandButtonTerms) {
                paymentChoice = paymentChoice == "counter" || paymentChoice == "touch_terminal" ? paymentChoice : "touch_terminal"
            }
            this.currSM.payment_type = paymentChoice;
            if (paymentChoice !== "cagnotte" && paymentChoice !== "cagnotte_fidelity") {
                this.rememberPaymentChoice = paymentChoice;
            }
            if (paymentChoice === "secure_counter" || paymentChoice === "counter") {
                this.setUseCreditClient(false);
            }
        } else {
            if (!this.currSM.payment_type || this.currSM.payment_type === "cagnotte" || this.currSM.payment_type === "cagnotte_fidelity") {
                if (this.rememberPaymentChoice) {
                    this.currSM.payment_type = this.rememberPaymentChoice;
                } else {
                    if (this.currSM.enable_online_payment > 0 && this.currPOS.stripeAccount) {
                        this.currSM.payment_type = "online";
                    } else if (this.currSM.enable_online_payment > 0 && this.currPOS.payzenAccount) {
                        this.currSM.payment_type = "payzen";
                    } else if (this.currSM.enable_counter_payment > 0) {
                        this.currSM.payment_type = this.currSM.enable_secure_counter_payment > 0 && this.currPOS.stripeAccount ? "secure_counter" : "counter";
                    } else {
                        this.currSM.payment_type = null;
                    }
                }
            }
        }

        // Mise à jour de l'interface utilisateur
        this.activePanierButton = !this.currSM.payment_type ? false : true;

        if (this.currSM.enable_device_check) {
            this.currSM.payment_type = 'counter';
        }

        this.currPaymentChoice = this.currSM.payment_type;
        this.smApi.setSaleMeth(this.currSM, true);
    }

    // Définir la propriété use_client_credit sur l'objet sale method
    setUseCreditClient(value: boolean): void {
        this.currSM.use_client_credit = value;
        this.tools.setStor(SalemethodService.TAG_STORAGE, this.currSM);
    }

    // Bascule la valeur de use_client_credit dans l'objet sale method
    toggleUseCredit(valueUse_client_credit?: any): void {
        if (!this.disabledCagnotte) {
            const newValue = valueUse_client_credit ? false : !this.currSM.use_client_credit;
            this.setUseCreditClient(newValue);
            this.toggleCagnotte();
        }
    }

    canUseCagnotte(): boolean {
        // console.log("endorder.component - canUseCagnotte - this.disabledCagnotte : ", this.disabledCagnotte);
        // console.log("endorder.component - canUseCagnotte - this.merchantClient : ", this.merchantClient);
        // console.log("endorder.component - canUseCagnotte - this.currSM : ", this.currSM);
        // console.log("endorder.component - canUseCagnotte - this.allTotal : ", this.allTotal);
        // console.log("endorder.component - canUseCagnotte - ce qui donne : ", !this.disabledCagnotte && this.merchantClient! && this.merchantClient.credit_amount > 0 && this.currSM.payment_type !== 'counter' && this.currSM.payment_type !== 'secure_counter' && this.allTotal > 0 && (this.currSM.enable_device_check !== 1));
        return !this.disabledCagnotte && this.merchantClient! && this.merchantClient.credit_amount > 0 && this.currSM.payment_type !== 'counter'
            && this.currSM.payment_type !== 'secure_counter' && this.allTotal > 0 && (this.currSM.enable_device_check !== 1);
        // counter et secure_counter sont les paiements au comptoir
    }

    // Détermine si les autres méthodes de paiement doivent être affichées
    toggleCagnotte(showFid?: boolean): void {
        let show: any = showFid ? showFid : true;

        this.allTotal = this.panierMan.getPriceWithDiscountClientAndFidelity(this.panierMan.getPanInfos("allship"), this.discountClient, this.fidelityDiscountUsed);

        if (this.currSM.use_client_credit) {
            if (
                this.merchantClient &&
                this.merchantClient.credit_amount >= this.allTotal) {
                show = false;
                this.setPaymentChoice("cagnotte");

            } else if (
                this.merchantClient &&
                this.merchantClient.credit_amount < this.allTotal
            ) {
                this.setPaymentChoice();
            }
        } else {
            this.setPaymentChoice();
        }

        this.showPaymentMethods = show;
    }

    // Définir la propriété use_client_credit sur l'objet sale method
    setUseCreditClientFid(value: boolean): void {
        this.currSM.use_client_credit_fid = value;
        this.tools.setStor(SalemethodService.TAG_STORAGE, this.currSM);
    }

    resetCagnotteFid_UseCreditFid(): void {
        this.toggleUseCreditFid("false");
        this.toggleUseCredit("false");
    }

    // Bascule la valeur de use_client_credit dans l'objet sale method
    toggleUseCreditFid(valueUse_credit?: any): void {
        const newValue = valueUse_credit ? false : !this.currSM.use_client_credit_fid;
        this.setUseCreditClientFid(newValue);
        this.toggleCagnotteFid();
    }

    // Condition d'affichage des modes de paiement autres que la cagnotte
    toggleCagnotteFid(): void {
        // Initialisation du flag pour indiquer si les méthodes de paiement doivent être affichées
        let show: any = true;

        // Réinitialise l'état où la cagnotte est désactivée
        this.disabledCagnotte = false;
        // Indique que le titre des méthodes de paiement doit être affiché
        this.showPaymentMethodsTitle = true;

        // Réinitialise la réduction utilisée du programme de fidélité
        this.fidelityDiscountUsed = 0;

        // Vérifie si le client peut utiliser des crédits de fidélité
        if (this.currSM.use_client_credit_fid && this.merchantClient && this.merchantClient.credit_fidelity_amount) {
            // Calcule le prix avec la remise du client
            const priceWithDiscount: any = this.allPrice - this.discountClient;

            // Calcule la réduction de fidélité maximale qui peut être appliquée
            this.fidelityDiscountUsed = priceWithDiscount > this.merchantClient.credit_fidelity_amount
                ? this.merchantClient.credit_fidelity_amount
                : this.allPrice - this.discountClient;

            // Calcule le total avec la remise et la réduction de fidélité
            this.allTotal = this.panierMan.getPriceWithDiscountClientAndFidelity(
                this.panierMan.getPanInfos("allship"), this.discountClient, this.fidelityDiscountUsed
            );

            // Si toute la commande peut être couverte par les crédits de fidélité
            if (this.fidelityDiscountUsed >= priceWithDiscount) {
                // Ne pas afficher d'autres méthodes de paiement, car les crédits de fidélité suffisent
                show = false;
                this.setPaymentChoice("cagnotte_fidelity");
                // Désactive l'utilisation d'autres crédits
                this.currSM.use_client_credit = false;
                this.disabledCagnotte = true;
                // Mémorise si on affichait les méthodes de paiement
                this.rememberPaymentChoice = show;
                // Ne pas afficher le titre des méthodes de paiement
                this.showPaymentMethodsTitle = false;
            } else {
                // Vérifie la nécessité d'afficher d'autres options de paiement
                this.toggleCagnotte(show);
            }
        } else {
            // Met à jour simplement le choix de paiement s'il n'y a pas assez de crédits de fidélité
            this.setPaymentChoice();
            this.toggleCagnotte();
        }
        // S'il s'agit d'un paiement par cagnotte, ne pas afficher d'autres méthodes de paiement
        if (this.currPaymentChoice == "cagnotte") {
            show = false;
        }
        this.showPaymentMethods = show;
    }

    // Affiche ou masque le panneau du panier
    toggleBasket(): void {
        this.rightNav.toggle();
    }

    // Ferme le panneau du panier
    closeBasket(): void {
        this.rightNav.close();
    }

    // Change la manière dont le panier est affiché en fonction de la taille du média
    getSidesResp(): void {
        if (this.media.isActive("gt-sm")) {
            // En mode 'side' si grand écran
            this.basketMode = "side";
            this.basketOpen = true;
        } else {
            // En mode 'over' si petit écran
            this.basketMode = "over";
            this.basketOpen = false;
        }
    }

    // Initialise le SDK PayPal si un compte est configuré
    initScriptPaypal(paypalAccountId: number): void {
        // Obtient la devise courante
        this.currencyMng.getCurrCurrency().subscribe((currency) => {
            // Crée un script pour intégrer le SDK PayPal
            const script = document.createElement("script");
            script.src = "https://www.paypal.com/sdk/js?client-id=" + paypalAccountId + "&currency=" + currency.code;
            this.elementRef.nativeElement.appendChild(script);
        });
    }

    // Méthode appelée lors de la sélection d'une méthode d'adresse de livraison
    onSelectDelivryMethod(i: number): void {
        this.isRelay = i === 1 ? true : false; // Détermine si le point relais est sélectionné
    }

    /**
     * Définir la propriété isRelay (réseau point relais) 
     * Appelée par le composant d'adresse de fin de commande lorsqu'une méthode de livraison change
     * @param newVal
     */
    setIsRelay(newVal: boolean): void {
        this.isRelay = newVal; // Assigne le nouveau point relais
    }

    // Définit si le point relais est sélectionné
    setSelectedRelay(relay: boolean): void {
        this.selectedRelay = relay; // Met à jour si le point relais est sélectionné ou non.
    }

    // Remet à zéro les points de fidélité
    resetFidelityPoints(): void {
        this.checFid = false;
        const NewPanier: any = this.panierMan.resetClientFidelityPoints()
        this.panierMan.setCurrentBasket(NewPanier, 'updateStock');
    }

    // Met à jour les valeurs de la cagnotte et des réductions
    roundedValCagnotteRemise(): void {
        // Effectue un arrondi sur la valeur de crédit du client
        if (this.merchantClient && this.merchantClient.credit_amount) {
            this.merchantClient.credit_amount = this.mathService.roundedVal(this.merchantClient.credit_amount)
        }

        // Effectue un arrondi sur la valeur de crédit fidélité du client
        if (this.merchantClient && this.merchantClient.credit_fidelity_amount) {
            this.merchantClient.credit_fidelity_amount = this.mathService.roundedVal(this.merchantClient.credit_fidelity_amount)
        }
    }

    // Événement déclenché lors du changement d'appareil (ex : en mode borne)
    devicechange($event: any): void {
        this.deviceChange = $event;
        // Active ou désactive le mode borne suivant l'appareil
        this.activeDeviceandButtonTerms = this.deviceChange == "currdevice" ? true : false;
    }

    // observable pour la gestion du paiement Stripe
    progressPaymentObservable(): void {
        this.obserProgress = this.stripeApi.getProgressPaymentStripe().subscribe(value => {
            if (value && this.savedDataStripe$ && this.payment_intent$)
                this.checkProgressPayment();
        });
    }

    // Statut final avant clôture
    finalStatusBeforeClose(infoStatus?: any): void {
        // Empêche des appels multiples une fois le statut réglé
        if (this.stopProgress) {
            return;
        }
        this.success = true;
        this.stopProgress = true;
        if (infoStatus && infoStatus.orderPayment && infoStatus.orderPayment.captured && infoStatus.orderPayment.captured == 1) {
            if (this.myDialFidelityOrder) {
                this.myDialFidelityOrder.close();
            }
            this.orderApi.endOrder(this.savedDataStripe$.order_id);
        } else {
            this.checkOrderPayment();
        }
        return;
    }

    ////// CHECKERS //////

    // Vérifie et recharge les zones éligibles si nécessaires
    async checkAndReloadEligibleZones(): Promise<void> {
        if (!this.currPOS || !this.currSM || this.currSM.enable_delivery !== 1) {
            return;
        }

        if (this.currPOS.eligibleZones.length > 0) {
            return;
        }

        // Recharger depuis l'API
        try {
            const PosId = this.tools.getStor("id_merchant")

            const eligibleZones = await this.posApi.getEligibleCities(PosId, this.currPOS.id);
            // console.log("eligibleZones: ", eligibleZones);

            if (eligibleZones && eligibleZones?.length > 0) {
                this.currPOS.eligibleZones = eligibleZones;
                this.tools.setStor("point_of_sale", this.currPOS);
            }
        } catch (error) {
            console.error('❌ Erreur rechargement eligible_zones:', error);
        }
    }

    // Vérifie si le panier contient des produits avec points fidélités utilisables par le client
    checkFidelityPoints(): void {
        // Empêche l'ouverture de plusieurs boîtes de dialogue
        if (this.myDialFidelityOrder && this.myDialFidelityOrder.getState() === MatDialogState.OPEN) {
            return;
        }
        // Récupère les points fidélité actuellement disponibles pour le client
        this.FidelityPointClient = this.panierMan.getClientFidelityPoints(this.merchantClient!.fidelity_points);
        // Crée un nouveau panier avec les points fidélité
        const newBasket = this.panierMan.getBasketFidelityPoints(this.FidelityPointClient);
        // Si le client a suffisamment de points fidélité, ouvre la boîte de dialogue
        if (newBasket.length > 0 && this.merchantClient!.fidelity_points >= 0) {
            this.checFid = this.panierMan.checkarrayfid(newBasket, this.merchantClient!.fidelity_points);
            if (this.checFid > 0) {
                this.tools.setStor('fidpoints', this.checFid);
                if (!this.success && !this.successYavin) {
                    this.openFidelityDial(newBasket); // Ouvre le dialogue de fidélité
                }
            }
        }
    }

    // Vérifie si le paiement de la commande a été capturé en cas de problème
    checkOrderPayment(): void {
        this.setPageIsLoading(true);
        this.stripeApi.checkOrderPayment(this.savedDataStripe$.order_id, null, this.savedDataStripe$.payment_intent).then((data: any) => {
            // Si le paiement est capturé
            if (data && data.code >= 0 && data.orderPayment && data.orderPayment.captured == 1 && data.paiement && data.paiement.status == "succeeded") {
                if (this.myDialFidelityOrder) {
                    this.myDialFidelityOrder.close();
                }
                this.setPageIsLoading(false);
                this.setPaymentChoice(data.payment_method);
                this.orderApi.endOrder(this.savedDataStripe$.order_id);
                this.success = false;
            } else {
                this.setPageIsLoading(false);
                this.tools.removeStor("payment_save_order");
                this.tools.removeStor("payment_save_order_stripe");
                this.savedDataStripe$ = null;
            }
            return;
        });
    }

    // Vérifie si le paiement dans la commande a été capturé
    checkProgressPayment(): void {
        this.maxcall++;
        // Vérifie si le paiement a été capturé
        this.stripeApi.getOrderPaymentStripe(this.savedDataStripe$.order_id, null, this.payment_intent$).then((data: any) => {
            const time_Exceeded = this.maxcall > 10 ? true : this.stripeApi.checkTimeExceeded(this.nowPayment);
            if (data && data.code < 0 || time_Exceeded || data.orderPayment && data.orderPayment.captured && data.orderPayment.captured == 1) {
                // Arrête l'interval si le paiement est capturé
                this.stripeApi.stopIntervalProgressPayment();
                // Note le statut de succès ou d'échec du paiement
                this.finalStatusBeforeClose(data);
            } else {
                // Redémarre les appels périodiques
                this.stripeApi.startIntervalProgressPayment();
            }
            return;
        });

    }

    ////// DIALOGS //////

    // Ouvre une alerte pour un problème de validité de produit
    openAlertProductValidty(errProductValidity: any) {
        // Configuration de la boîte de dialogue
        const myConf = new MatDialogConfig();
        myConf.data = { errProductValidity: errProductValidity }
        myConf.panelClass = "dialog-responsive"
        // Ajustement de la taille de la boîte de dialogue pour petits ou grands écrans
        this.media.isActive("xs")
            ? (myConf.width = "100%")
            : (myConf.width = "550px");
        const myDial = this.dialog.open(AlertExpireDateProductDialogComponent, myConf);
        myDial.afterClosed().subscribe(() => {
            if (this.basketlength == 0) {
                this.tools.goProductPage();
            }
        })
    }

    // Ouvre un dialogue pour la gestion des cartes de paiement
    openCardMethodsDial(ev: any): void {
        // Si la liste des cartes n'est plus en chargement
        if (!this.clientCardLoader) {
            // Configuration du dialogue
            const myConf = new MatDialogConfig();
            myConf.data = {
                clientCards: this.clientCards$,
                card: ev
            };

            // Ajuste la taille du dialogue en fonction de la taille de l'écran
            this.media.isActive("xs")
                ? (myConf.width = "100%", myConf.height = "100%")
                : (myConf.width = "550px", myConf.height = "80%");

            // Ouvre le dialogue
            const myDial = this.dialog.open(PaymentsMethodsCardComponent, myConf);

            // Change l'état de l'historique du navigateur pour gérer le retour arrière
            this.tools.setOnPopState(true);

            // Abonnement pour gérer la fermeture du dialogue
            myDial.afterClosed().subscribe((result) => {
                if (result) {
                    // Met à jour la liste des cartes clients si modifiée
                    this.clientCards$ = result.cards;
                }
            });
        }
    }

    // Ouvre la boîte de dialogue de confirmation de commande
    openConfirmOrder(): void {
        // Configuration de la boîte de dialogue
        const myConf = new MatDialogConfig();
        myConf.autoFocus = false;
        myConf.disableClose = true;
        myConf.data = {
            card: this.currCard$,
            billingAddress: this.currBillingAddress$,
            delivryAddress: this.currDelivryAddress$,
            relay: this.isRelay ? this.selectedRelay : null,
            merchantClient: this.merchantClient
        };
        // Adapter la largeur en fonction de la taille de l'écran
        this.media.isActive("xs") ? (myConf.panelClass = "full-w") : (myConf.width = "500px");
        // Ouverture de la boîte de dialogue
        const myDial = this.dialog.open(ConfirmorderComponent, myConf);
        myDial.afterClosed().subscribe(() => {
        });
    }

    // Ouvre la boîte de dialogue pour gestion des dates d'expiration
    openExpiredateDial(): void {
        // Configuration de la boîte de dialogue
        const myConf = new MatDialogConfig();
        myConf.disableClose = true;
        // Ajustement de la taille de la boîte de dialogue pour petits ou grands écrans
        this.media.isActive("xs")
            ? (myConf.width = "80%", myConf.height = "50%")
            : (myConf.width = "550px", myConf.height = "50%");
        // Ouverture de la boîte de dialogue
        const myDial = this.dialog.open(ExpireDateDialogComponent, myConf);
        myDial.afterClosed().subscribe(() => {
            // Vide le panier après avoir fermé la boîte de dialogue
            this.statusMessage = "loaderRedirc_"
            this.setPageIsLoading(true);
            this.tools.goProductPage();
        });
    }

    // Ouvre la boîte de dialogue pour sélectionner des produits avec points fidélité
    openFidelityDial(newclientBasket: any): void {
        if (!this.clientCardLoader && (!this.success && !this.successYavin)) {
            // Configuration de la boîte de dialogue
            const myConf = new MatDialogConfig();
            myConf.data = {
                clientBasket: newclientBasket,
                clientFidelityPoint: this.merchantClient!.fidelity_points,
            };
            // Ajustement de la taille de la boîte de dialogue pour petits ou grands écrans
            this.media.isActive("xs")
                ? (myConf.width = "100%", myConf.height = "100%")
                : (myConf.width = "550px", myConf.minHeight = "500px");
            // Ouverture de la boîte de dialogue
            this.myDialFidelityOrder = this.dialog.open(FidelityOrderComponent, myConf);

            // Gère l'historique du navigateur pour la boîte de dialogue ouverte
            this.tools.setOnPopState(true);

            // Gestion de la fermeture de la boîte de dialogue
            this.myDialFidelityOrder.afterClosed().subscribe((result: any) => {
                if (result) {
                    // Met à jour le panier
                    const NewPanier = this.panierMan.setBasketFidelityPoints(result.basket);
                    this.panierMan.setCurrentBasket(NewPanier, 'updateStock');
                }
                // Recalcule les points de fidélité restants pour le client
                this.FidelityPointClient = this.panierMan.getClientFidelityPoints(this.merchantClient!.fidelity_points);
            });
        }
    }

    // JAMAIS APPELEE
    // openPaymentMethodsDial(ev?: any): void {
    //     // Si les cartes clients sont chargées
    //     if (!this.clientCardLoader) {
    //         // Configuration du dialogue
    //         const myConf = new MatDialogConfig();
    //         myConf.data = {
    //             clientCards: this.clientCards$,
    //             card: ev
    //         };

    //         // Ajuste la taille du dialogue
    //         this.media.isActive("xs")
    //             ? (myConf.width = "100%", myConf.height = "100%")
    //             : (myConf.width = "550px", myConf.minHeight = "500px");

    //         // Ouvre le dialogue
    //         const myDial = this.dialog.open(PaymentMethodsComponent, myConf);

    //         // Change l'état de l'historique du navigateur pour gérer le retour arrière
    //         this.tools.setOnPopState(true);

    //         // Abonnement pour les résultats à la fermeture du dialogue
    //         myDial.afterClosed().subscribe((result) => {
    //             if (result) {
    //                 // Met à jour les cartes et la méthode de paiement est sélectionnée
    //                 this.clientCards$ = result.cards;
    //                 this.setPaymentChoice(result.payment_method);
    //             }
    //         });
    //     }
    // }

    ////// GETTERS //////

    // Met à jour le montant de la remise pour le client
    getPriceRemise(): void {
        this.discountClient = this.mathService.roundedVal(this.allPrice - this.panierMan.getTotalAfterDiscount(this.merchantClient));
        this.allTotal -= this.discountClient;
    }

    ////// SETTERS //////

    // Définit l'état de chargement de la page
    setPageIsLoading(value: boolean, verify?: string): void {
        // Si verify est vrai et que le paiement a été un succès
        this.pageIsLoading = (verify && (this.success || this.successYavin)) ? true : value;
    }
}